import React from 'react'
import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { Button } from 'components/button'
import { MODAL_KEYS } from 'app-constants'
import { setModal } from 'slices/modal'
import './style.scss'

export function GoToPaymentLink({ paymentLink }) {
  const dispatch = useDispatch()

  function handlePaymentClick() {
    window.open(paymentLink)
    dispatch(setModal({ key: MODAL_KEYS.NONE }))
  }

  return (
    <div className='container-credit-payment'>
      <div className='container-icon'>
        <STATICS.CREDIT_WARNING />
      </div>
      <span className='text'>
        Você será redirecionado para concluir o pagamento com cartão de crédito.
      </span>
      <div className='container-button'>
        <Button onClick={handlePaymentClick} color='primary' className='button'>
          Ir para pagamento {'>'}
        </Button>
      </div>
    </div>
  )
}
